import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import { AbconetApi } from '../General/AbconetApi';
var GroupSelector = require('../General/Selectors/GroupSelector').GroupSelector;
var ProductSelector = require('../General/Selectors/ProductSelector').ProductSelector;
var SiteSelector = require('../General/Selectors/SiteSelector').SiteSelector;
import ViewSwitcher from "../General/ViewSwitcher";
var GeneralLedgerSelector = require('../General/Selectors/GeneralLedgerSelector').GeneralLedgerSelector;

export class ApprovedStocklistEditLine extends React.Component {

    removeItem(ev) {
        ev.preventDefault();
        this.props.removeItemClick();
    }

    render() {
        var product = this.props.templateLine.product;
        var line = this.props.templateLine;
 
        var size = product.imageFileName == 'no-image.svg' ? '40' : '';

        //if (this.props.isCompactView) {
            return (
                <div className="item" key={product.stockcode}>
                    <div className="row">
                        <div className="col-1 ">
                            <span className="stockcode">{product.stockcode}</span>
                        </div>
                        <div className="col-4">
                            <p className="description">{product.name}</p>
                        </div>
                        <div className="col-3 ">
                            <GeneralLedgerSelector  key={product.stockcode} accountId={this.props.accountId} isClearable field="generalLedgerAccountCode" id="generalLedgerAccountCode" className="form-control" value={line.generalLedgerAccountCode}  />
                        </div>
                        <div className="col-3 ">
                            <GeneralLedgerSelector key={"stockcode-" + product.stockcode} accountId={this.props.accountId} isClearable field="generalLedgerAccountRechargeableCode" id="generalLedgerAccountRechargeableCode" className="form-control" value={line.generalLedgerAccountRechargeableCode} />
                        </div>
                        <div className="col-1 text-center">
                            <span >
                                <a href="#" onClick={this.removeItem.bind(this)}><i className="icon icon-close lead"></i></a>
                            </span>
                        </div>
                    </div>
                </div>
            );
        //} 


        //return (
        //    <div className="item" key={product.stockcode}>
        //        <div className="row">
        //            <div className="col-1">
        //                {/*<a href={product.url}><img src={`${product.imageFileName}`} className="product-image" width={size} /></a>*/}
        //            </div>
        //            <div className="col-4">
        //                <p className="description">{product.name}</p>
        //                <span className="stockcode">Code: {product.stockcode}</span>
        //            </div>
        //            <div className="col-3 ">
        //                <GeneralLedgerSelector key={product.stockcode} accountId={this.props.accountId} isClearable field="generalLedgerAccountCode" id="generalLedgerAccountCode" className="form-control" value={line.generalLedgerAccountCode}  />
        //            </div>
        //            <div className="col-3 ">
        //                <GeneralLedgerSelector key={product.stockcode} accountId={this.props.accountId} isClearable field="generalLedgerAccountRechargeableCode" id="generalLedgerAccountRechargeableCode" className="form-control" value={line.generalLedgerAccountRechargeableCode} />
        //            </div>
        //            <div className="col-1 actions-container rechargeable-column">
        //                <span >
        //                    <a href="#" onClick={this.removeItem.bind(this)}><i className="icon icon-close lead"></i></a>
        //                </span>
        //            </div>
        //        </div>
        //    </div>
        //);
    }
}


export class ApprovedStocklistEdit extends React.Component {

    constructor(props) {
        super(props);
        this.cronText = React.createRef();
        this.state = {
            isSaved: true,
            permissionsModalOpen: false,
            isSaving: false,
            isGroupSaved: true,
            isGroupSaving: false,
            permissions: null,
            submittedValues: this.props.initialState,
            isCompactView: false
        }
    }

    setViewSwitcher(data) {
        this.setState({ isCompactView: data.isCompactView });
    }

    componentDidMount() {
        this.loadGroupPermissionAndLinkedSite();
    }


    setChange() {
        this.setState({ isSaved: false });
    }
    setGroupChange() {
        this.setState({ isGroupSaved: false });
    }

    addNewLineKeyPress(formApi, ev) {
        if (ev.keyCode === 13 && (formApi.values.productSearch != '' && formApi.values.productSearch != undefined)) {
            ev.preventDefault();
            this.addNewLine(formApi);
        }
    }

    addNewLine(formApi) {
        if (isNullOrUndefined(formApi.values.productSearch) || formApi.values.productSearch == "") {
            alert('Please select a product...');

            return;
        }

        var lineCollection = this.formApi.getValue("lines");

        var index = -1;
        if (!isNullOrUndefined(lineCollection)) {
            index = lineCollection.findIndex(function (obj) {
                return obj.product['stockcode'] === formApi.values.productSearch.stockcode;
            });
        }

        if (index <= -1) {
            formApi.addValue('lines',
                {
                    product: formApi.values.productSearch,
                    quantity: 0,
                    rechargeable: false
                });

            formApi.setValue('productSearch', '');
        } else {
            alert('Product already exists on list.');
        }
    }

    openScheduleModal() {
        this.setState({
            scheduleModalOpen: true
        });
    }

    closeScheduleModal() {
        this.setState({
            scheduleModalOpen: false
        });
    }

    openPermissionsModal(ev) {
        ev.preventDefault();
        this.setState({
            permissionsModalOpen: true
        });
    }

    closePermissionsModal() {
        this.setState({
            permissionsModalOpen: false
        });
    }


    submitTemplate(submittedValues) {
        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);
    }

    submitGroupAndLinkedSite(shared) {
        this.setState({ shared, isGroupSaving: true }, this.saveGroupAndLinkedSite);
    }

    saveGroupAndLinkedSite() {
        AbconetApi.post(`/api/approved-stocklists/${this.props.initialState.id}/permissions`, this.state.shared.permission).then(
            () => {
                setTimeout(
                    () => {
                        this.setState({ isGroupSaved: true, isGroupSaving: false });

                        setTimeout(() => {
                            this.closePermissionsModal();
                        },
                            300);
                    },
                    200);
            });

        AbconetApi.post(`/api/approved-stocklists/${this.props.initialState.id}/site`, this.state.shared.siteCollection).then(
            () => {
                setTimeout(
                    () => {
                        this.setState({ isGroupSaved: true, isGroupSaving: false });

                        setTimeout(() => {
                            this.closePermissionsModal();
                        },
                            300);
                    },
                    200);
            });
    }

    loadGroupPermissionAndLinkedSite() {
        if (this.props.initialState.id <= 0) {
            return;
        }

        AbconetApi.get(`/api/approved-stocklists/${this.props.initialState.id}/grouppermissionandlinkedsite`, this.state.shared).then((shared) => {
            this.setState({ shared });
        });
    }


    sendStateToServer() {
        var self = this;

        //console.log('this.state.submittedValues', this.state.submittedValues);

        AbconetApi.post('/api/approved-stocklists/', this.state.submittedValues).then(approvedStockList => {
            if (this.props.initialState.id === 0) {
                window.location = `/approved-stocklists/${approvedStockList.id}/`;
            }

            self.setState({ isSaved: true, submittedValues: approvedStockList, isSaving: false });

        });
    }

    removeLine(line) {
        var lineCollection = this.formApi.getValue("lines");

        var index = lineCollection.findIndex(function (obj) {
            return obj.product['stockcode'] === line.product.stockcode;
        });

        lineCollection.splice(index, 1);

        this.formApi.setValue("lines", lineCollection);

        this.state = {
            isSaved: false
        }
    }

    renderTableHeader(lines) {
        if (lines == null || lines.length === 0) {
            return;
        }

        var switcher = <div className="col-12">
                           <ViewSwitcher onChange={this.setViewSwitcher.bind(this)} />
                       </div>;

        return <div className="row header">
            {/*{switcher}*/}
            <div className="col-1"> </div>
            <div className="col-4 col-hd text-center">
                Item
            </div>
            <div className="col-3 col-hd text-center">
                GL Code
            </div>
            <div className="col-3 col-hd text-center">
                GL Code Rechargeable
            </div>
            <div className="col-1 col-hd text-center">
                
             </div>
        </div>;
    }


    renderSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }


        if (this.props.initialState.id === 0) {
            btnText = "Create";
        }

        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }


        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    renderShareSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isGroupSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }

        if (this.state.isGroupSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }


        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isGroupSaved || this.state.isGroupSaving}>{btnText}</button>;
    }

    renderUpperButtons() {
        if (this.formApi.getValue("lines") != null && this.formApi.getValue("lines").length >= 5) {
            return <div>
                {this.renderSaveButton()}
            </div>;

        }
    }

    renderShareButton() {
        if (this.props.initialState.id === 0) {
            return;
        }

        if (this.state.shared == null) {
            return;
        }

        return <button className="btn btn-primary float-right" onClick={this.openPermissionsModal.bind(this)}>Share</button>;
    }

    renderPermissions()
    {
        if (this.props.initialState.id === 0) {
            return;
        }

        if (this.state.shared == null) {
            return;
        }

        if (this.state.shared.permission != null && this.state.shared.permission.view.length <= 0) {
            return;
        }

        var list;
        if (this.state.shared.permission.view) {
            list = this.state.shared.permission.view.map((permission) => {
                return <li className="">{permission.description}</li>;
            });
        }
       
        return <div>
           Group:
            <ul className="list-inline">
            {list}
            </ul>
        </div>;

    }

    renderSiteList() {
        if (this.props.initialState.id === 0) {
            return;
        }

        if (this.state.shared == null) {
            return;
        }

        if (this.state.shared.siteCollection.length <= 0) {
            return;
        }

        var siteList;
        if (this.state.shared.siteCollection) {
            siteList = this.state.shared.siteCollection.map((site) => {
                return <li className="">{site.fullAddress}</li>;
            });
        }

        return <div>
                Site:
                <ul className="list-inline">
                    {siteList}
                </ul>
        </div>;

    }

    render() {
        var self = this;
        var extraListClass = '';
        if (this.state.isCompactView) {
            extraListClass = ' list-compact';
        }

            return (
            <div className="approvedStockList approvedStockList-edit">
                <ReactModal isOpen={this.state.permissionsModalOpen} onRequestClose={this.closePermissionsModal.bind(this)} portalClassName="modal-portal modal-portal-permission" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h3 className="m-0">Share</h3>
                        </div>
                        <div className="modal-body">
                            <Form
                                defaultValues={this.state.shared}

                                onChange={this.setGroupChange.bind(this)}
                                onSubmit={this.submitGroupAndLinkedSite.bind(this)}>
                                {formApi => (
                                    <form onSubmit={formApi.submitForm} id="dynamic-form">
                                        <h5>Group:</h5>
                                        <GroupSelector field="permission.view" />

                                        <h5>Site:</h5>
                                        <SiteSelector field="siteCollection" isMulti />

                                        <br />
                                        {this.renderShareSaveButton()}
                                    </form>
                                )}
                             </Form>
                        </div>
                        <button onClick={this.closePermissionsModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </ReactModal>

                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitTemplate.bind(this)} defaultValues={this.props.initialState}>
                    {formApi => {
                        self.formApi = formApi;

                        return (
                            <div>
                                <form onSubmit={formApi.submitForm} id="dynamic-form">
                                    <div className="card card-body bg-light">
                                        <label htmlFor="dynamic-approvedStockList-name">Name:</label>
                                        <Text field="name" id="dynamic-approvedStockList-name" className="form-control" /> <br />
                                        {this.renderPermissions()}
                                        {this.renderSiteList()}
                                        <div>
                                            {this.renderShareButton()}
                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <h5>
                                                Add stock to list
                                            </h5>
                                        </div>

                                        <div className="col-12 col-lg-7">
                                            <div className="row">
                                                <div className="col-9">
                                                    <ProductSelector field="productSearch" onKeyDown={self.addNewLineKeyPress.bind(self, formApi)}/>
                                                </div>
                                                <div className="col-3">
                                                    <button
                                                        onClick={self.addNewLine.bind(self, formApi)}
                                                        type="button"
                                                        className="mb-4 mr-4 btn btn-success">Add</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-5">
                                            {this.renderUpperButtons()}
                                        </div>
                                    </div> <br /><br />
                                    <div className={"list-group" + extraListClass}>
                                        {this.renderTableHeader(formApi.values.lines)}

                                        {formApi.values.lines &&
                                            formApi.values.lines.map((line, i) => (
                                                <NestedField field={['lines', i]} key={"approvedStockList-lines-" + i}>
                                                    <ApprovedStocklistEditLine templateLine={line} removeItemClick={this.removeLine
                                                        .bind(self, line)} isCompactView={this.state.isCompactView} accountId={this.props.initialState.accountId} />
                                                </NestedField>
                                            ))}
                                    </div>
                                    <a href="/approved-stocklists" className="btn btn-outline-primary">View all approved stocklists</a>
                                    {this.renderSaveButton()}
                                </form>

                            </div>
                        );
                    }}
                </Form>
            </div>
        );
    }
}